import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button, Card, Container } from "react-bootstrap";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-US");
};

const DriverAbstractList = () => {
  const navigate = useNavigate();
  const { id: paramId } = useParams();

  const role = localStorage.getItem("userRole");
  const isAdmin = role === "1";
  const loggedInId = localStorage.getItem("userId");
  const userId = isAdmin && paramId ? paramId : loggedInId;

  const [records, setRecords] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/driverabstract/${userId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setRecords(res.data || []);
      } catch (err) {
        console.error("Error fetching driver's abstracts", err);
      }
    };

    if (userId) fetchData();
  }, [userId]);

  return (
    <Container className="form-wrapper my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Driver&apos;s Abstract</h3>
        <div>
          <Button
            variant="secondary"
            className="me-2"
            onClick={() =>
              navigate(isAdmin && paramId ? `/userhome/${paramId}` : "/userhome")
            }
          >
            Return
          </Button>
          <Button
            variant="success"
            onClick={() => navigate(`/driverabstract/${userId}/new`)}
          >
            Add
          </Button>
        </div>
      </div>

      <Card>
        <Card.Body>
          {records.length === 0 ? (
            <div className="text-muted text-center">
              No driver&apos;s abstracts found.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "5%" }}>#</th>
                    <th style={{ width: "12%" }}>Date Saved</th>
                    <th style={{ width: "15%" }}>Saved By</th>
                    <th style={{ width: "12%" }}>Date Created</th>
                    <th style={{ width: "15%" }}>Created By</th>
                    <th style={{ width: "10%" }}>Date Issued</th>
                    <th style={{ width: "10%" }}>Medical Expiration</th>
                    <th style={{ width: "10%" }}>Points Type</th>
                    <th style={{ width: "6%" }}>Points</th>
                    <th style={{ width: "8%" }}>No Violations</th>
                    <th style={{ width: "5%" }}>Files</th>
                    <th style={{ width: "110px" }} className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((record, index) => (
                    <tr key={record.da_id}>
                      <td>{index + 1}</td>
                      <td>{formatDate(record.da_updated_date)}</td>
                      <td>{record.saved_by || "-"}</td>
                      <td>{formatDate(record.da_created_date)}</td>
                      <td>{record.created_by || "-"}</td>
                      <td>{formatDate(record.da_date_issued)}</td>
                      <td>{formatDate(record.da_medical_expiration)}</td>
                      <td>{record.da_points_type || "-"}</td>
                      <td>{record.da_points ?? 0}</td>
                      <td>{record.da_no_violations || "-"}</td>
                      <td>{record.file_count || 0}</td>
                      <td className="text-center">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() =>
                            navigate(
                              `/driverabstract/${userId}/detail/${record.da_id}`
                            )
                          }
                        >
                          Edit
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default DriverAbstractList;
